<template>
  <el-select
    v-model="status"
    :size="size"
    clearable=""
    style="width: 100px;"
    placeholder="全部打单状态"
    @change="onChange">
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
import { PrintStatusName } from '../../utils/index'
export default {
  name: 'TypeSelect',
  props: {
    callback: {
      type: Function
    },
    size: {
      type: String,
      default: 'small'
    },
    type: {
      type: String,
      default: 'select'
    },
    value: {
      required: true
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      list: PrintStatusName
    }
  },
  computed: {
    status: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange() {
      this.callback && this.callback()
    }
  }
}
</script>
